'use strict';
import {epics as reduxListEpics} from '../redux';
import {injector as activeTimersInjector} from '../redux/activeTimers';
import {injector as timerLogConfigInjector} from '../redux/timerLogConfig';
import {epics as onStartTimerEpics} from './onStartTimer';

const angular = require('angular');

export const epicsModule = angular
  .module('app.timers.epics', [])
  .run(activeTimersInjector)
  .run(timerLogConfigInjector)
;

export const epics = [
  ...reduxListEpics,
  ...onStartTimerEpics,
];



// WEBPACK FOOTER //
// ./src/js/timers/epics/index.js